import { i18n as e } from "../../i18n.mjs";
import { ToolbarSelect as t } from "../../components/content-controls/toolbar-select.mjs";
import { ToolbarSheetSelect as n } from "../../components/content-controls/toolbar-sheet-select.mjs";
import { LINE_HEIGHT_ATTRIBUTE as r, LINE_HEIGHT_TYPES as i } from "./constants.mjs";
import { useEditorState as a } from "@tiptap/react";
import { useMemo as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import { LineHeightIcon as c } from "@systemeio/icons";
//#region src/extensions/line-height-extension/use-line-height-extension-toolbar.tsx
var l = [
	1,
	1.15,
	1.5,
	2,
	2.5,
	3
], u = () => l.map((e) => ({
	value: e,
	label: `${e}`
})), d = (e) => {
	let t = e.attrs[r];
	return typeof t == "number" || typeof t == "string" ? t : null;
}, f = (e, t, n) => {
	if (!e || t === void 0 || n === void 0) return !1;
	if (t === n) return i.some((t) => e.isActive(t));
	let r = !1;
	return e.state.doc.nodesBetween(t, n, (e) => {
		if (i.includes(e.type.name)) return r = !0, !1;
	}), r;
}, p = (e, t, n) => {
	if (!e || t === void 0 || n === void 0) return null;
	if (t === n) {
		let n = e.state.doc.resolve(t);
		for (let e = n.depth; e >= 0; e--) {
			let t = n.node(e);
			if (i.includes(t.type.name)) return d(t);
		}
		return null;
	}
	let r = null, a = !1;
	return e.state.doc.nodesBetween(t, n, (e) => {
		if (i.includes(e.type.name)) {
			let t = d(e);
			return r === null ? r = t : r !== t && (a = !0), !1;
		}
	}), a ? null : r;
}, m = (r) => {
	let i = a({
		editor: r,
		selector: ({ editor: e }) => {
			let t = e?.state.selection.from, n = e?.state.selection.to;
			return {
				isDisabled: !e?.options.editable || !f(e, t, n),
				lineHeight: p(e, t, n)
			};
		}
	}), l = i?.isDisabled ?? !1, d = i?.lineHeight ?? null;
	return o(() => {
		let i = (e) => {
			r && r.chain().focus().setLineHeight(e).run();
		};
		return {
			toolbarRender: /* @__PURE__ */ s(t, {
				disabled: l,
				label: e.t("line_height"),
				onChange: i,
				options: u(),
				value: d,
				children: /* @__PURE__ */ s(c, {})
			}),
			sheetRender: /* @__PURE__ */ s(n, {
				disabled: l,
				icon: /* @__PURE__ */ s(c, {}),
				label: e.t("line_height"),
				onChange: i,
				options: u(),
				value: d
			})
		};
	}, [
		r,
		l,
		d
	]);
};
//#endregion
export { m as useLineHeightExtensionToolbar };
